export enum ROUTE {
  LANDING_PAGE = "/",
  COST_ITEMS = "/cost-items",
  GROUP_MEMBER = "/group-member",
  CALCULATION = "/calculation",
  FAQ = "/faq",
  ABOUT = "/about",
  BLOG = "/blog",
}
